module.exports = __webpack_public_path__ + "img/logo.ef66c3fd.png";